import { IReassigmentProvider } from '../../interfaces/service/ReassignmentServiceManagerInterface';
import {
  ChangeEvent,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useDeviceTypesCatalogs } from '../../hooks/catalogs/useDeviceTypesCatalogs';
import { useSamTypes } from '../../hooks/inventory/useSamTypes';
import { useReassigment } from '../../hooks/reassigment/useReassignment';
import { StoreContext } from '../../context/Provider';
import { MultiSelectChangeEvent } from 'primereact/multiselect';
import { RadioButtonChangeEvent } from 'primereact/radiobutton';
import {
  // reassigmentColumnActions,
  torniqueteVRTGaritaPOSCAU,
  cetSac,
  samFarm,
} from '../../pages/Reassignment/components/table/helper';
import { FilterMatchMode } from 'primereact/api';
import { DataTableFilterMeta } from 'primereact/datatable';
import {
  IFilterData,
  IReassignmentDataToSend,
  IReassignmentDTO,
  SelectDeviceData,
  SelectSamData,
  IFormInformation,
  SamTypeInterface,
  ColumnConfig,
  ColumnConfigWithBody,
  ISamReassignmentDTO,
  IDeviceReassignmentDTO,
  IDeviceTypeFilter,
  IUniqueDeviceTypes,
  UniqueEntry,
} from '../../interfaces/interfaceReassignment';
import { ToastComponent } from '../../components/ToastComponent';
import {
  extractGroupedUniqueEntries,
  filterByDeviceTypeEnum,
  getCatalogForm,
  getFilteredDeviceTypes,
  TypeSamEnum,
} from '../../utils/utils';
import {
  deviceDataTableColumns,
  samDataTableColumns,
} from '../../pages/Reassignment/utils';

export const ReassigmentContextSM = createContext<IReassigmentProvider>(
  {} as IReassigmentProvider
);

const initFilterValues: IFilterData = {
  deviceTypeData: [],
  samTypesData: [],
};

const initSelectDeviceValues: SelectDeviceData = {
  stations: [],
  locations: [],
  projects: [],
  routes: [],
  economicNumbers: [],
  pcModules: [],
  socket: [],
  readersIds: [],
};

const initSelectSamValues: SelectSamData = {
  sams: [],
  samTypes: [],
};

const initDataToSend: IReassignmentDataToSend = {
  stationId: null,
  locationId: null,
  projectId: null,
  routeId: null,
  economicNumberId: null,
  pcModuleId: null,
  reason: '',
  DeviceId: 0,
};

export const ReassignmentProvider = (props: any) => {
  const [filterData, setFilterData] = useState<IFilterData>(initFilterValues);
  const [selectDeviceData, setSelectDeviceData] = useState<SelectDeviceData>(
    initSelectDeviceValues
  );
  const [selectSamData, setSelectSamData] =
    useState<SelectSamData>(initSelectSamValues);
  const [dataToSend, setDataToSend] =
    useState<IReassignmentDataToSend>(initDataToSend);
  const [radioSelection, setRadioSelection] = useState<'SAM' | 'Device'>('SAM');
  const [openRightMenu, setOpenRightMenu] = useState<boolean>(false);
  const [deviceFormInfo, setDeviceFormInfo] = useState<IFormInformation[]>([]);
  const [filterSamId, setFilterSamId] = useState<string>('');
  const [reassignmentSamData, setReassignmentSamData] = useState<
    ISamReassignmentDTO[]
  >([]);
  const [samTableData, setSamTableData] = useState<any[]>([]);

  const [reassignmentDeviceData, setReassignmentDeviceData] = useState<
    IDeviceReassignmentDTO[]
  >([]);

  const [samTypeSelected, setSamTypeSelected] = useState<SamTypeInterface[]>(
    []
  );
  const [samSelectedForDataToSend, setSamSelectedForDataToSend] =
    useState<number>(0);
  const [deviceTypeSelected, setDeviceTypeSelected] = useState<
    IDeviceTypeFilter[]
  >([]);

  const [columnsSelected, setColumnsSelected] =
    useState<ColumnConfigWithBody[]>(samDataTableColumns);
  const [availableDevice, setAvailableDevice] = useState<IUniqueDeviceTypes[]>(
    []
  );
  const [availableDeviceSam, setAvailableDeviceSam] = useState<
    IUniqueDeviceTypes[]
  >([]);

  const [formDeviceSelected, setFormDeviceSelected] = useState<string>('');
  const [selectMenu, setSelectMenu] = useState<string>('');
  const [dataRow, setDataRow] = useState<IReassignmentDTO>({
    Id: 0,
    SamId: '',
    SamTypeId: 0,
    SamTypeName: '',
    DetachedDate: '',
    DetachedNotes: '',
    DeviceId: 0,
    DeviceTypeEnum: 0,
    DeviceTypeId: 0,
    DeviceTypeName: '',
    Notes: '',
    StationId: null,
    StationName: '',
    LocationId: null,
    LocationName: '',
    ProjectId: 0,
    ProjectName: '',
    RouteId: null,
    RouteName: '',
    EconomicNumberId: null,
    EconomicNumber: '',
    PcModuleId: null,
    PcModuleName: '',
    SocketId: null,
    SamTypeEnum: 0,
    DeviceNumber: '',
  });

  const [sort, setSort] = useState([{ field: '', order: -1 }]);

  const [filters] = useState<DataTableFilterMeta>({
    samId: { value: null, matchMode: FilterMatchMode.CONTAINS },
    samTypeName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    detachedDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    detachedNotes: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const { getDeviceTypesCatalog } = useDeviceTypesCatalogs();

  const { getSamTypes } = useSamTypes();

  const { getReassignment, patchReassignment } = useReassigment();

  const { getSamTypesStates, getDeviceTypesCatalogState } =
    useContext(StoreContext);

  useEffect(() => {
    getDeviceTypes();
    getSamTypesData();
    getDeviceData();
    setRadioSelection('SAM');
  }, []);

  useEffect(() => {
    if (getDeviceTypesCatalogState.state.data !== null) {
      const { data } = getDeviceTypesCatalogState.state;

      setFilterData({
        ...filterData,
        deviceTypeData: data,
      });
    }
  }, [getDeviceTypesCatalogState.state]);

  useEffect(() => {
    if (getSamTypesStates.state.data !== null) {
      const { data } = getSamTypesStates.state;
      setFilterData({
        ...filterData,
        samTypesData: data,
      });
    }
  }, [getSamTypesStates.state]);

  useEffect(() => {
    setDataToSend(initDataToSend);
    if (!openRightMenu) formInformation(0);
    if (radioSelection === 'Device') {
      setDataToSend({
        ...dataToSend,
        stationId: dataRow.StationId ?? null,
        locationId: dataRow.LocationId ?? null,
        projectId: dataRow.ProjectId ?? null,
        routeId: dataRow.RouteId ?? null,
        economicNumberId: dataRow.EconomicNumberId ?? null,
        pcModuleId: dataRow.PcModuleId ?? null,
      });
    }
    setFormDeviceSelected('');
    setSelectSamData({
      ...selectSamData,
      sams: [],
    });
  }, [openRightMenu]);

  async function getSamTypesData() {
    return await getSamTypes();
  }

  async function getDeviceTypes() {
    return await getDeviceTypesCatalog();
  }

  async function getSAMData() {
    try {
      const result = await getReassignment('SAM');

      setSamTableData(result.data);

      mapSamTypeData(result.data);
      setReassignmentSamData(result.data);
    } catch (error) {
      console.error('Error fetching device data', error);
    }
  }

  async function getDeviceData() {
    try {
      const result = await getReassignment('Device');

      setReassignmentDeviceData(result.data);
      const _availableDevice = getUniqueDeviceTypeNames(result.data);

      setAvailableDevice(_availableDevice);

      return getSAMData();
    } catch (error) {
      console.error('Error fetching device data', error);
    }
  }

  function onDeviceTypeChange(e: MultiSelectChangeEvent) {
    const selected = e.value ?? [];
    setDeviceTypeSelected(selected);

    if (selected.length === 0) {
      setSamTableData(reassignmentDeviceData);
      return;
    }

    const selectedIds = selected.map(
      (type: IDeviceTypeFilter) => type.deviceTypeId
    );

    const filteredDevices = reassignmentDeviceData.filter(
      (device: IDeviceReassignmentDTO) =>
        selectedIds.includes(device.DeviceTypeId)
    );

    setSamTableData(filteredDevices);
  }

  function onSamIdChange(samId: string) {
    setFilterSamId(samId);
    applySamFilters(samId, samTypeSelected);
  }

  function onSamTypeChange(e: MultiSelectChangeEvent) {
    const selected = e.value ?? [];
    setSamTypeSelected(selected);
    applySamFilters(filterSamId, selected);
  }

  function onFormDeviceTypeChange(e: number) {
    const res = extractGroupedUniqueEntries(e, reassignmentDeviceData);

    formInformation(e);
    setFormDeviceSelected(e.toString());
    setSelectDeviceData(res);
  }

  function onFormSamTypeChange(e: number) {
    const res = mapSamDataBySamType(e);
    setSelectSamData({
      ...selectSamData,
      sams: res.sams,
    });
  }

  function onSamIdSelection(samId: number) {
    setSamSelectedForDataToSend(samId);
  }

  function handleSelectChange(
    name: keyof IReassignmentDataToSend,
    value: number
  ) {
    const newDataToSend = {
      ...dataToSend,
      [name]: value,
    };
    const res = getCatalogForm(
      formDeviceSelected,
      reassignmentDeviceData,
      newDataToSend,
      deviceFormInfo
    );

    setSelectDeviceData(res);

    console.log('resultado', res);

    setDataToSend({
      ...dataToSend,
      [name]: value,
    });
  }

  function onRadioChange(e: RadioButtonChangeEvent | string) {
    const _radioSelection = typeof e === 'string' ? e : e.value;

    if (_radioSelection === 'SAM') {
      setSelectMenu('SAM');

      setSamTableData(reassignmentSamData);
      applySamFilters(filterSamId, samTypeSelected);
      setColumnsSelected(samDataTableColumns);
    } else if (_radioSelection === 'Device') {
      setSelectMenu('Device');

      setSamTableData(reassignmentDeviceData);
      setColumnsSelected(deviceDataTableColumns);
      onDeviceTypeChange({
        value: deviceTypeSelected,
      } as MultiSelectChangeEvent);
    }
    setRadioSelection(_radioSelection);
  }

  function reassignHandler(row: any) {
    const nonReassignableTypes = new Set([
      TypeSamEnum.Inicializacion,
      TypeSamEnum.Emision,
      TypeSamEnum.RecargaMonedero,
    ]);

    // Verificar si el tipo de dispositivo no permite reasignación
    if (nonReassignableTypes.has(row.SamTypeEnum)) {
      ToastComponent(
        'warning',
        'Error',
        'Este dispositivo no se puede reasignar'
      );
      return;
    }

    if (radioSelection === 'Device') {
      console.log('row.DeviceTypeEnum', row.DeviceTypeEnum);
      setFormDeviceSelected(row.DeviceTypeEnum.toString());
    }

    const filteredDeviceTypes = getFilteredDeviceTypes(row.SamTypeEnum);

    if (filteredDeviceTypes.length > 0) {
      const filteredDevices = filterByDeviceTypeEnum(
        availableDevice,
        filteredDeviceTypes
      );

      setAvailableDeviceSam(filteredDevices);
    }

    setOpenRightMenu(true);
    setDataRow(row);

    if (radioSelection === 'Device') {
      formInformation(row.DeviceTypeEnum);
    }
  }

  function onSubmit() {
    if (formDeviceSelected === '' && selectSamData.sams.length === 0) {
      ToastComponent(
        'warning',
        'Error',
        'Por favor seleccione un tipo de equipo y un SAM.'
      );
      return;
    }
    patchReassignmentData();
  }

  async function patchReassignmentData() {
    let headerId: number = 0;

    if (radioSelection === 'SAM') {
      headerId = dataRow.Id;
    } else if (radioSelection === 'Device') {
      headerId = samSelectedForDataToSend;
    }

    return await patchReassignment(
      {
        deviceId: dataToSend.DeviceId,
        reason: dataToSend.reason,
      },
      headerId
    ).finally(async () => {
      setOpenRightMenu(false);

      return await getDeviceData().finally(() => {
        if (radioSelection === 'Device') {
          setSamTableData(reassignmentDeviceData);
        }
      });
    });
  }

  function applySamFilters(samId: string, selectedTypes: SamTypeInterface[]) {
    let filtered = reassignmentSamData;

    if (samId && samId.trim() !== '') {
      const lowerSamId = samId.toLowerCase();
      filtered = filtered.filter((item: ISamReassignmentDTO) =>
        (item.SamId || '').toLowerCase().includes(lowerSamId)
      );
    }

    if (selectedTypes.length > 0) {
      const selectedIds = selectedTypes.map(
        (type: SamTypeInterface) => type.samTypeId
      );
      filtered = filtered.filter((item: ISamReassignmentDTO) =>
        selectedIds.includes(item.SamTypeId)
      );
    }

    setSamTableData(filtered);
  }

  function handleSelectColumn(e: MultiSelectChangeEvent) {
    console.log('e.value xxxxxxxxxxxxxxxxxxx', e.value);
    setColumnsSelected(e.value);

    e.stopPropagation();
  }

  function handleReasonChange(e: ChangeEvent<HTMLTextAreaElement>) {
    const { value } = e.target;
    setDataToSend({
      ...dataToSend,
      reason: value,
    });
  }

  function formInformation(infoForm: number) {
    const torniqueteForms = new Set([1, 2, 3, 6, 7]);
    const cetSacForms = new Set([4, 5]);

    if (torniqueteForms.has(infoForm)) {
      setDeviceFormInfo(torniqueteVRTGaritaPOSCAU);
    } else if (cetSacForms.has(infoForm)) {
      setDeviceFormInfo(cetSac);
    } else if (infoForm === 8) {
      setDeviceFormInfo(samFarm);
    } else {
      setDeviceFormInfo([]);
    }
  }

  function truncateText(text: string, maxChars = 30) {
    return text.length > maxChars ? text.slice(0, maxChars) + '...' : text;
  }

  function mapSamDataBySamType(samTypeId: number | string) {
    const samTypeIdNumber = Number(samTypeId);

    const filtered = reassignmentSamData.filter(
      sam => sam.SamTypeId === samTypeIdNumber
    );

    const uniqueSams = Array.from(
      new Map(filtered.map(sam => [sam.SamId, sam])).values()
    );

    return {
      sams: uniqueSams.map(sam => ({
        SamId: sam.Id ?? null,
        SamName: sam.SamId ?? '',
      })),
    };
  }

  function mapSamTypeData(reassignmentSamData: any[]) {
    const _uniqueSamTypes = Array.from(
      new Map(reassignmentSamData.map(type => [type.SamTypeId, type])).values()
    );

    const _samTypes = _uniqueSamTypes
      .filter(type => [4, 5, 6, 7].includes(type.SamTypeEnum))
      .map(type => ({
        SamTypeId: type.SamTypeId ?? null,
        SamTypeName: type.SamTypeName ?? '',
        SamTypeEnum: type.SamTypeEnum ?? '',
      }));
    setSelectSamData({
      ...selectSamData,
      samTypes: _samTypes,
    });
  }

  function getUniqueDeviceTypeNames(_reassignmentDeviceData: any[]) {
    const seen = new Set<number>();
    const uniqueTypes: IUniqueDeviceTypes[] = [];

    _reassignmentDeviceData.forEach(device => {
      if (!seen.has(device.DeviceTypeEnum)) {
        seen.add(device.DeviceTypeEnum);
        uniqueTypes.push({
          DeviceTypeEnum: device.DeviceTypeEnum,
          DeviceTypeName: device.DeviceTypeName,
        });
      }
    });

    return uniqueTypes;
  }

  function closeRightMenu() {
    setOpenRightMenu(false);
  }

  return (
    <ReassigmentContextSM.Provider
      value={{
        dataRow,
        openRightMenu,
        filterSamId,
        filterData,
        samTableData,
        samTypeSelected,
        deviceTypeSelected,
        radioSelection,

        columnsSelected,
        filters,
        sort,
        selectMenu,
        formDeviceSelected,
        availableDevice,
        selectDeviceData,
        selectSamData,
        deviceFormInfo,

        handleSelectColumn,
        handleSelectChange,

        setOpenRightMenu,
        setSort,

        onSamIdChange,
        onDeviceTypeChange,
        onSamTypeChange,
        onRadioChange,
        handleReasonChange,
        onFormDeviceTypeChange,
        onFormSamTypeChange,
        onSamIdSelection,
        onSubmit,
        truncateText,
        closeRightMenu,
        availableDeviceSam,
        reassignHandler,
        dataToSend,
      }}>
      {props.children}
    </ReassigmentContextSM.Provider>
  );
};
